import { toast } from "react-toastify";
import ApiService from "./api";

export const printPDFCard = (orderId: number, filename = "payments-export"): Promise<void> => {
  return ApiService.fetchData({
    url: `order-export/${orderId}`, // Assuming there's an export endpoint
    method: "GET",

    responseType: "blob", // Important: We need to handle binary data
  })
    .then((response) => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response]));

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;

      // Set the file name (you might want to get this from headers)
      link.setAttribute(
        "download",
        `${filename}-${new Date().toISOString().split("T")[0]}.pdf`
      );

      // Append to body, click, and clean up
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    })
    .catch((error) => {
      toast.error("Failed to download payments report.");
    });
};
